import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/moban/1.jpg'
import _imports_1 from '@/assets/moban/2.jpg'
import _imports_2 from '@/assets/moban/3.jpg'
import _imports_3 from '@/assets/moban/4.jpg'
import _imports_4 from '@/assets/moban/5.jpg'
import _imports_5 from '@/assets/moban/6.jpg'
import _imports_6 from '@/assets/moban/7.jpg'
import _imports_7 from '@/assets/moban/8.jpg'
import _imports_8 from '@/assets/moban/9.jpg'


const _hoisted_1 = { class: "template-gallery" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-actions" }

import { useRouter } from 'vue-router'
import { ArrowLeft } from '@element-plus/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TemplateGallery',
  setup(__props) {

const router = useRouter()

const goBack = () => {
  router.push('/')
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "logo" }, "芝麻开花智能写作平台", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: goBack,
          type: "primary",
          plain: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowLeft))
              ]),
              _: 1
            }),
            _cache[0] || (_cache[0] = _createTextVNode(" 返回首页 "))
          ]),
          _: 1
        })
      ])
    ]),
    _cache[2] || (_cache[2] = _createStaticVNode("<main class=\"main-content\" data-v-1fc521bf><div class=\"gallery-container\" data-v-1fc521bf><div class=\"left-section\" data-v-1fc521bf><div class=\"tab-container\" data-v-1fc521bf><div class=\"tab-item active\" data-v-1fc521bf><span class=\"tab-text\" data-v-1fc521bf>万字论文（截取版）</span></div></div></div><div class=\"right-section\" data-v-1fc521bf><div class=\"image-gallery\" data-v-1fc521bf><div class=\"image-item\" data-v-1fc521bf><img src=\"" + _imports_0 + "\" alt=\"模板1\" class=\"template-image\" data-v-1fc521bf></div><div class=\"image-item\" data-v-1fc521bf><img src=\"" + _imports_1 + "\" alt=\"模板2\" class=\"template-image\" data-v-1fc521bf></div><div class=\"image-item\" data-v-1fc521bf><img src=\"" + _imports_2 + "\" alt=\"模板3\" class=\"template-image\" data-v-1fc521bf></div><div class=\"image-item\" data-v-1fc521bf><img src=\"" + _imports_3 + "\" alt=\"模板4\" class=\"template-image\" data-v-1fc521bf></div><div class=\"image-item\" data-v-1fc521bf><img src=\"" + _imports_4 + "\" alt=\"模板5\" class=\"template-image\" data-v-1fc521bf></div><div class=\"image-item\" data-v-1fc521bf><img src=\"" + _imports_5 + "\" alt=\"模板6\" class=\"template-image\" data-v-1fc521bf></div><div class=\"image-item\" data-v-1fc521bf><img src=\"" + _imports_6 + "\" alt=\"模板7\" class=\"template-image\" data-v-1fc521bf></div><div class=\"image-item\" data-v-1fc521bf><img src=\"" + _imports_7 + "\" alt=\"模板8\" class=\"template-image\" data-v-1fc521bf></div><div class=\"image-item\" data-v-1fc521bf><img src=\"" + _imports_8 + "\" alt=\"模板9\" class=\"template-image\" data-v-1fc521bf></div></div></div></div></main>", 1))
  ]))
}
}

})